import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GseApiConfiguration } from '../../../api/gse/gse-api-configuration';
import { StrictHttpResponse } from '../../../api/gse/strict-http-response';
import {
  getAllSpareAllocationRequests,
  GetAllSpareAllocationRequests$Params,
} from '../../../api/gse/fn/spare-allocation/get-all-spare-allocation-requests';
import {
  getSpareAllocationRequestDetails,
} from '../../../api/gse/fn/spare-allocation/get-spare-allocation-request-details';
import {
  allocateSpares,
} from '../../../api/gse/fn/spare-allocation/allocate-spares';
import { GetSpareAllocationRequestsResponse } from '../../../api/gse/models/get-spare-allocation-requests-response';
import { SpareAllocationRequestDetailsResponse } from '../../../api/gse/models/spare-allocation-request-details-response';
import { AllocateSparesRequest } from '../../../api/gse/models/allocate-spares-request';

@Injectable({ providedIn: 'root' })
export class SpareAllocationService {
  private http = inject(HttpClient);
  private config = inject(GseApiConfiguration);

  private get rootUrl(): string {
    return this.config.rootUrl;
  }

  getAll(
    params?: GetAllSpareAllocationRequests$Params
  ): Observable<StrictHttpResponse<GetSpareAllocationRequestsResponse>> {
    return getAllSpareAllocationRequests(this.http, this.rootUrl, params);
  }

  getDetails(id: number): Observable<StrictHttpResponse<SpareAllocationRequestDetailsResponse>> {
    return getSpareAllocationRequestDetails(this.http, this.rootUrl, { id });
  }

  allocate(
    id: number,
    body: AllocateSparesRequest
  ): Observable<StrictHttpResponse<SpareAllocationRequestDetailsResponse>> {
    return allocateSpares(this.http, this.rootUrl, { id, body });
  }
}
